// Ecommerce Logging Manager

const CChannelUtils = {
	createChannel: (channel, { isCustom = false } = {}) => ({
		value: `__cc_${channel}`,
		isConsellChannel: true,
		name: channel[0].toUpperCase() + channel.slice(1).toLowerCase(),
		isCustom: isCustom,
	}),
};

const CChannel = {
	_default: CChannelUtils.createChannel("default"),
	debug: CChannelUtils.createChannel("debug"),
	status: CChannelUtils.createChannel("status"),
	error: CChannelUtils.createChannel("error"),
	custom(channel) {
		return CChannelUtils.createChannel(channel, { isCustom: true });
	},
};

const consell = {
	// Private memebers
	_outputChannels: [CChannel.status, CChannel.error, CChannel.debug],
	_prefix: "Consell: ",
	_enabledOnLive: false,
	_isPreview: location.href.includes("shopifypreview"),
	_showStackTrace: true,
	_history: [],
	_filename: "logger.js",
	_allowed() {
		return this._enabledOnLive || this._isPreview;
	},
	_correctChannel(messages) {
		const lastMessage = messages.length > 0 ? messages.slice(-1)[0] : null;
		const isChannel = !!lastMessage && lastMessage.isConsellChannel;
		const channel = isChannel ? lastMessage.value : CChannel._default;
		const outputs = [...this._outputChannels, CChannel._default].map(
			(c) => c.value
		);
		return outputs.includes(channel);
	},
	_removeChannels(messages) {
		return messages.filter((m) => !m.isConsellChannel);
	},
	_output(name, messages) {
		if (!this._allowed()) return;
		//if (!this._correctChannel(messages)) return;
		messages = this._removeChannels(messages);
		const historyEntry = {
			method: name,
			messages: messages,
			loggedAt: new Date(),
		};

		console[name](this._prefix, ...messages);

		if (this._showStackTrace) {
			let savedError = null;
			// This is a hacky way of generating a stack trace without 'arguments.callee'
			// An error object contains a stack trace, so I cause a ReferenceError on purpose then modify the error object
			try {
				CAUSE_AN_ERROR_ON_PURPOSE_CUZ_IM_DANGEROUS;
			} catch (error) {
				savedError = this._generateStackTrace(error, name);
			}

			console.log(savedError);
			historyEntry.stackTrace = savedError;
		}

		this._history = [historyEntry, ...this._history];
	},
	_generateStackTrace(error, method) {
		// Modify the error so it doesn't look like an error
		error.name = "Consell";
		error.message = `${method} was called from:`;
		// Find the function call location
		const newStack = error.stack
			.split("\n")
			.filter((f) => !f.includes(this._filename))[0];
		error.stack = newStack;
		return error;
	},
	// Console interface
	log(...messages) {
		this._output("log", messages);
	},
	warn(...messages) {
		this._output("warn", messages);
	},
	error(...messages) {
		this._output("error", messages);
	},
	info(...messages) {
		this._output("info", messages);
	},
	debug(...messages) {
		this._output("debug", messages);
	},
	clear(...messages) {
		if (!this._allowed()) return;
		console.clear();
	},

	// Rich console features
	count(name) {
		if (!this._allowed()) return;
		console.count(name);
	},
	countReset(name) {
		if (!this._allowed()) return;
		console.countReset(name);
	},
	assert(condition, ...messages) {
		if (!this._allowed()) return;
		console.assert(condition, ...messages);
	},
	dir(obj) {
		if (!this._allowed()) return;
		console.dir(obj);
	},
	table(data) {
		if (!this._allowed()) return;
		console.table(data);
	},

	// State management
	enable() {
		this._enabledOnLive = true;
	},
	disable() {
		this._enabledOnLive = false;
	},
	toggle() {
		this._enabledOnLive = !this._enabledOnLive;
	},
	get enabled() {
		return this._allowed();
	},
	set enabled(value) {
		this._enabledOnLive = value;
	},

	enableStackTrace() {
		this._showStackTrace = true;
	},
	disableStackTrace() {
		this._showStackTrace = false;
	},
	toggleStackTrace() {
		this._showStackTrace = !this._showStackTrace;
		return this._showStackTrace;
	},

	// History Control
	clearHistory() {
		const oldHistory = this._history;
		this._history = [];
		return oldHistory;
	},
	lastLog() {
		return this._history[0] || "None!";
	},
	get last() {
		return this._lastLog();
	},
	get history() {
		return this._history;
	},

	help() {
		const consoleMethods = Object.keys(console);
		const methods = Object.keys(consell).filter(
			(n) => n[0] !== "_" && n !== "help" && !consoleMethods.includes(n)
		);

		const output = methods
			.map((method) => {
				let isGetter = false;
				try {
					isGetter = typeof consell[method] !== "function";
				} catch (error) {
					isGetter = true;
				}

				return `consell.${method}${isGetter ? "" : "()"}`;
			})
			.sort((a) => !a.includes("()"))
			.join(", ");

		console.log(`Methods: console API, ${output}`);
		return "";
	},
};
